/**
 * FIXME: Improve implementation in order to avoid three levels of containers dependency and change
 * this container into a component with hooks, maybe to allow to change color tabs indicator, change
 * color tab background and also hide or remove some tabs based on some value obtained from the store.
 */

import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { usePathParam, useViewport } from '@chilecompra/react-kit'
import { checkIfForeignDni } from '../../modules/utils/helpers'
import AppBar from '../../components/Surfaces/AppBar'
import Tab from '../../components/Navigation/Tab'
import Tabs from '../../components/Navigation/Tabs'
import TabPanel from '../../components/Surfaces/TabPanel'
import { Column } from './SellerTabWrapper.styles'
import { sendAnalyticsEvent } from '../../config/settings/analytics'
/**
 * The Seller Tab Wrapper's container.
 */
const SellerTabWrapper = props => {
  const { accessibility, options, prefix } = props
  const {
    size: { isDownToSmall, isUpToMedium }
  } = useViewport()
  const [value, setValue] = useState(0)

  const { error: sellerError, loading, contractStatus } = useSelector(state => state.basicSellerInformation)
  const { error: summaryError } = useSelector(state => state.summarySection)

  const dni = usePathParam('rut')
  const isForeign = checkIfForeignDni(dni)

  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const position = options.findIndex(tab => tab.current)

    if (position === value || position === -1) {
      return
    }

    setValue(position)
  }, [pathname])

  const tabProps = index => {
    return {
      id: `${prefix}-tab-${index}`,
      'aria-controls': `${prefix}-tabpanel-${index}`,
      key: `${prefix}-tab-${index}`,
      value: index
    }
  }

  const tabPanelProps = index => {
    return {
      id: `${prefix}-tabpanel-${index}`,
      ariaLabel: `${prefix}-tab-${index}`
    }
  }

  const handleChange = (_, newValue) => {
    if (newValue === value) {
      return
    }

    navigate(options[newValue].route)
    sendAnalyticsEvent({
      action: `Click tab ${options[newValue].label}`,
      category: 'click-tab-ficha',
      label: options[newValue].label
    })
  }

  const optionsTabs = loading
    ? options
    : options.filter(option => option.show && option.show({ contractStatus, summaryError }))

  return sellerError || (summaryError?.reason === 'FORBIDDEN_ERROR' && isForeign) ? null : (
    <Column margin="0 0 2rem 0" padding={isUpToMedium ? '0 27px 0 0' : '0'}>
      <AppBar
        position="static"
        tabsCount={optionsTabs.filter(value => value.show({ contractStatus, summaryError })).length}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label={accessibility.label}
          variant="scrollable"
          scrollButtons={isDownToSmall ? 'on' : 'auto'}
        >
          {optionsTabs.map((option, index) => {
            return <Tab label={option.label} key={`${prefix}-tab-${index}`} {...tabProps(index)} loading={loading} />
          })}
        </Tabs>
      </AppBar>

      {optionsTabs.map((option, index) => {
        return (
          <TabPanel value={value} index={index} key={`${prefix}-tabpanel-${index}`} {...tabPanelProps(index)}>
            {option.content}
          </TabPanel>
        )
      })}
    </Column>
  )
}

SellerTabWrapper.defaultProps = {
  accessibility: {
    label: 'Simple tabs'
  }
}
SellerTabWrapper.propTypes = {
  accessibility: PropTypes.shape({
    label: PropTypes.string
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node.isRequired,
      current: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired
    })
  ).isRequired,
  prefix: PropTypes.string.isRequired
}

export default SellerTabWrapper
